export function topBanner() {
    const topBanner = document.querySelector('.top-banner');
    if (!topBanner) {
        return;
    }
    return new TopBanner(topBanner);
}

class TopBanner {
    static get DEFAULT_DELAY() {
        return 3;
    };

    static get HEIGHT() {
        return 40;
    };

    #intervalId = null;
    #activeIndex = 0;
    /** @type {number} */
    #delay;
    /** @type {HTMLUListElement} */
    #wrapper;
    /** @type {NodeListOf<HTMLLIElement>} */
    #messages;
    /** @type {HTMLLIElement[]} */
    #clones;
    /** @type {number} */
    #messagesCount;

    constructor(topBanner) {
        this.#delay = Number(topBanner.dataset.delay || TopBanner.DEFAULT_DELAY);
        this.#wrapper = topBanner.querySelector('.top-banner-wrapper');
        this.#messages = topBanner.querySelectorAll('.top-banner-message');
        this.#clones = [this.#messages[0].cloneNode(true)];
        this.#messagesCount = this.#messages.length + this.#clones.length;

        this.#clones.forEach(node => {
            node.classList.add('top-banner-message-clone');
            node.setAttribute('aria-hidden', 'true');
            this.#wrapper.append(node);
        });
        this.#wrapper.addEventListener('transitionend', () => {
            if (this.activeIndex === this.#messagesCount - 1) {
                this.#wrapper.style.transition = 'none';
                this.activeIndex = 0;
                setTimeout(() => this.#wrapper.style.transition = '');
            }
        });
        this.start();
    }

    get activeIndex() {
        return this.#activeIndex;
    }

    set activeIndex(index) {
        this.#activeIndex = index;
        this.#slideUp();
    }

    start() {
        this.#intervalId = setInterval(() => this.activeIndex = this.#nextIndex(), this.#delay * 1000);
    }

    stop() {
        clearInterval(this.#intervalId);
        this.#intervalId = null;
    }

    #slideUp() {
        this.#wrapper.style.transform = `translateY(${-this.activeIndex * TopBanner.HEIGHT}px)`;
    }

    #nextIndex() {
        return (this.#activeIndex + 1) % this.#messagesCount;
    }
}
